// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----Footer-module---footer---VUGIP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.module.scss
// module id = 255
// module chunks = 168707334958949